import { Header, SidebarTrigger } from '@ntconsult/aluma-react';
import { LanguageMenu } from './LanguageMenu';
import { ThemeMenu } from './ThemeMenu';
import { UserMenu } from './UserMenu';

export function AppHeader() {
  return (
    <Header>
      <Header.Start>
        <SidebarTrigger />
      </Header.Start>
      <Header.Center />
      <Header.End>
        <LanguageMenu />
        <ThemeMenu />
        <UserMenu />
      </Header.End>
    </Header>
  );
}
